export const ERROR_STATE = {
  MAX_SIZE: 'MAX_SIZE',
  INVALID_FORMAT: 'INVALID_FORMAT',
  SIZE_AND_FORMAT: 'SIZE_AND_FORMAT',
  CONVERTING_FAILED: 'CONVERTING_FAILED',
};

export const FILE_STATUS = {
  READY: 'READY',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  PENDING: 'PENDING',
  CONVERT: 'CONVERT',
  CONVERTING: 'CONVERTING',
};

export const ACTION = {
  FETCH_GALLERY: 'FETCH_GALLERY',
  FETCH_GALLERIES: 'FETCH_GALLERIES',
  FETCH_PHOTOS: 'FETCH_PHOTOS',
  SET_ACTIVE_GALLERY: 'SET_ACTIVE_GALLERY',
  RESET_STATE: 'RESET_STATE',
};

export const REDIRECT = { FROM_NEW_GALLERY: 'FROM_NEW_GALLERY' };

export const ENUM_PROFILE_GALLERY_TYPE = {
  PROFILE: 'PROFILE',
  PUBLIC: 'PUBLIC',
  FANCLUB: 'FANCLUB',
  SAFE_FOR_WORK: 'SAFE_FOR_WORK',
};

export const TAB = {
  PHOTOS: 0,
  ADD_PHOTOS: 1,
  EDIT_PHOTOS: 2,
};

export const PHOTO_STATUS = {
  NOT_SAFE_FOR_WORK: 'NSFW',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
};

export const CANCEL_REQUEST = 'CANCEL_REQUEST';
export const PROFILE_GALLERY_NAME = 'Profile Images';
export const SFW_GALLERY_NAME = 'SFW Gallery';
// in MB
export const MAX_IMAGE_SIZE = 12;
export const MAX_IMAGES_READY_TO_UPLOAD = 10;
export const MAX_GALLERY_NAME_CHARS = 70;
